// extracted by mini-css-extract-plugin
module.exports = {"callToClick":"styles_callToClick__2Jbm2","specificTable":"styles_specificTable__2T4Sy"};